import { useState } from 'react';

export const useCopyToClipboard = (): ((text: string) => Promise<boolean>) => {
  const [, setCopied] = useState(false);

  const copyToClipboard = async (text: string): Promise<boolean> => {
    if (!navigator?.clipboard) {
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);

      return true;
    } catch {
      setCopied(false);

      return false;
    }
  };

  return copyToClipboard;
};
